import React, { useEffect, useState } from "react";

import SearchBar from "../../components/SearchBar/SearchBar";
import Carousel from "../../components/Carousel/Carousel";

import { useDispatch } from "react-redux";
import { cleanSearch } from "../../actions/searchActions";

import Axios from "../../services/Api";
import app_params from "../../config/params";
// import { library_info } from "../../data/homeInfo";
import "./HomeScreen.css"; //

const HomeScreen = (props) => {
  const [lastAcquisitions, setLastAcquisitions] = useState({
    records: [],
    hasDetailPage: false,
  });
  // const [visitCount, setVisitCount] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(cleanSearch());
  }, [dispatch]);

  useEffect(() => {
    Axios.GetLatestAcquisitions()
      .then((res) => res.data)
      .then((data) =>
        setLastAcquisitions(
          data?.success ? data : { records: [], hasDetailPage: false }
        )
      )
      .catch((e) => {
        // console.log(e);
        setLastAcquisitions({ records: [], hasDetailPage: false });
      });

    // Axios.GetVisits()
    //   .then((res) => res.data)
    //   .then((data) => setVisitCount(data?.success ? data?.count : 0))
    //   .catch((e) => {
    //     console.log(e);
    //     setVisitCount(0);
    //   });
  }, []);

  return (
    <section className="container">
      <div className="bg-white mx-0 mx-md-3 my-3 px-3 px-md-4 px-xl-5 py-5 shadow-sm rounded">
        <div className="row col-12 d-flex justify-content-center mb-2">
          <div className="col-12 col-lg-8 col-xl-6">
            <form action={`${app_params.basepath}/query`}>
              <SearchBar />
            </form>
          </div>
        </div>
        <div className="text-center">
          <a href={`${app_params.basepath}/advancedsearch`}>
            Búsqueda avanzada
          </a>
        </div>
      </div>
      <div className="bg-white mx-0 mx-md-3 mt-3 mb-2 px-3 px-md-4 px-xl-5 py-4 shadow-sm rounded">
      <div className="row d-flex align-items-stretch">
      <div className="col-12 col-md-6 d-flex flex-column justify-content-between">
            <h5 className="text-center fw-bold mb-4">Biblioteca Rivera Tyng</h5>
            <p style={{ textAlign: 'justify' }}>
              Nuestra biblioteca se conforma gracias a generosas donaciones de importantes colecciones personales de textos especializados en temas relacionados con las ciencias sociales, tales como arqueología mesoamericana, epigrafía maya, arqueología de las culturas del mundo, etnología, antropología física, historia, etnohistoria, sociología, antropología, botánica, biología, idiomas, lingüística y gramática. Además, contamos con material fotográfico antiguo de sitios arqueológicos del país.
            </p>
            <p style={{ textAlign: 'justify' }}>
              También poseemos una sección infantil con material didáctico orientado a la enseñanza sobre las culturas prehispánicas de Mesoamérica, mediante cuentos.
            </p>
            <p style={{ textAlign: 'justify' }}>
              La colección consta de un acervo de 10,088 libros, los cuales siguen en constante aumento. Estos recursos contribuyen a la divulgación de la arqueología mesoamericana y temas afines, y están destinados tanto para investigadores especializados como para el público en general, ofreciendo un espacio educativo y ameno para los visitantes. De esta manera, promovemos la práctica de la lectura y la investigación en la población.
            </p>
            <p style={{ textAlign: 'justify' }}>
              Nuestras instalaciones cuentan con medidas óptimas para la conservación del material resguardado y con una sala de consulta adecuada.
            </p>
            <p style={{ textAlign: 'justify' }}>
              El horario de atención al público es de lunes a viernes, de 9:00 a.m. a 15:00 p.m. La consulta de material se realiza bajo cita previa, enviando un correo electrónico a <a href="mailto:biblioteca@fundacionrutamaya.org">biblioteca@fundacionrutamaya.org</a>, indicando el nombre, los temas de interés y el día deseado para agendar la visita. Posteriormente, se responderá al correo para confirmar la fecha propuesta.
            </p>
            <p style={{ textAlign: 'justify' }}>
              Un agradecimiento a la Academia de Geografía e Historia de Guatemala, por medio del Dr. Miguel Torres, por su donación para la realización de mejoras en nuestra página.
            </p>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
  <div id="bibliotecaCarousel" className="carousel slide w-100" data-bs-ride="carousel">
    <div className="carousel-indicators">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          data-bs-target="#bibliotecaCarousel"
          data-bs-slide-to={i}
          className={i === 0 ? "active" : ""}
          aria-current={i === 0 ? "true" : undefined}
          aria-label={`Slide ${i + 1}`}
        ></button>
      ))}
    </div>
    <div className="carousel-inner">
      {[1, 2, 3, 4, 5, 6].map((i, index) => (
        <div key={i} className={`carousel-item ${index === 0 ? "active" : ""}`}>
          <img
            src={`${app_params.basepath}/assets/menu/img${i}.jpg`}
            className="d-block w-100 img-fluid rounded shadow-sm"
            alt={`img${i}`}
          />
        </div>
      ))}
    </div>
    <button
      className="carousel-control-prev"
      type="button"
      data-bs-target="#bibliotecaCarousel"
      data-bs-slide="prev"
    >
      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
      <span className="visually-hidden">Anterior</span>
    </button>
    <button
      className="carousel-control-next"
      type="button"
      data-bs-target="#bibliotecaCarousel"
      data-bs-slide="next"
    >
      <span className="carousel-control-next-icon" aria-hidden="true"></span>
      <span className="visually-hidden">Siguiente</span>
    </button>
  </div>
</div>

  </div>
</div>


      <Carousel
        title={"Novedades"}
        items={lastAcquisitions?.records}
        hasDetailPage={lastAcquisitions?.hasDetailPage}
      />
      {/* <div className="bg-white mx-0 mx-md-3 my-3 p-3 shadow-sm rounded">
        <div
          className="row p-2"
          dangerouslySetInnerHTML={{ __html: library_info.description }}
        ></div>
      </div> */}
      {/* <div className="bg-white mx-0 mx-md-3 my-3 p-3 shadow-sm rounded">
        <div className="row p-2">
          <div className="col-12 text-center">
            Usted es el visitante # {visitCount}
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default HomeScreen;
